import { QarepaApiErrorDictionary } from '@qarepa/common';

export const apiErrorDictionary: QarepaApiErrorDictionary = {
  E0000: `La solicitud contiene datos inválidos.`,
};

export const bypassErrorCodes: string[] = [
  'E0003',
  'E0004',
  'E0006',
  'E0007',
  'E0008',
  'E0010',
  'E0012',
  'E0013',
  'E0014',
  'E0015',
  'E0017',
  'E0018',
  'E0019',
  'E0020',
  'E0021',
  'E0022',
  'E0025',
  'E0030',
  'E0031',
  'E0032',
  'E0036',
  'E0037',
];
